import React from 'react'

import ConnectedDatePicker from 'src/comps/ConnectedDatePicker'
import { SearchMode } from 'src/types/search'

export function DatePicker() {
  return (
    <div data-testid="datepicker-wrapper">
      <ConnectedDatePicker mode={SearchMode.Full} />
    </div>
  )
}
